import api from "./Api";

class ServicosCnaeDetService {
  GetServicosCnaeDet(payload) {
    return api.get("/v1/servicosCnaeDet/" + payload).then((response) => {
      return response.data;
    });
  }

  PostServicosCnaeDet(payload) {
    return api.post("/v1/servicosCnaeDet/", payload).then((response) => {
      return response.data;
    });
  }

  PutServicosCnaeDet(payload) {
    return api.put("/v1/servicosCnaeDet/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteServicosCnaeDet(payload) {
    return api.delete("/v1/servicosCnaeDet/" + payload).then((response) => {
      return response.data;
    });
  }

  GetServicosCnaeDetOData(payload) {
    return api.get("/OData/ServicosCnaeDet" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ServicosCnaeDetService();
